import catalogData from '../../../data/catalog.json';
import { CategoryItem, CategoryKey } from '../types/store';

export const CATEGORIES: CategoryItem[] = catalogData.categories as CategoryItem[];

export function getCategoryByKey(key: string): CategoryItem | undefined {
  return CATEGORIES.find((category) => category.key === key);
}

export function getCategoryIcon(categoryKey: CategoryKey): string {
  return getCategoryByKey(categoryKey)?.icon ?? '💊';
}
